import styled from "styled-components"

const StyledStrategyTiles = styled.div`
  margin: 0 0 150px 0;

  @media (max-width: 991px) {
    margin: 0 0 90px 0;
  }

  .row {
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @media (max-width: 991px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .item {
    position: relative;
    min-height: 300px;
    width: 100%;
    max-width: 33.33333%;
    background-color: gray;
    margin: 30px 0 0 0;
    overflow: hidden;

    &:not(:last-child) {
      margin-right: 15px;

      @media (max-width: 991px) {
        margin-right: 0;
      }
    }

    h2 {
      font-size: 48px;
      color: #00fb6e;
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      text-align: center;
      transform: translate(-50%, -50%);
      text-transform: uppercase;

      @media (max-width: 575px) {
        font-size: 32px;
      }
    }

    &__inner {
      position: absolute;
      top: 0;
      left: 0;
      background-color: #fff;
      border: 5px solid #00fb6e;
      width: 100%;
      height: 100%;
      padding: 30px 25px 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      transition: all 150ms linear;
      transform: translate(0, 100%);

      @media (max-width: 575px) {
        padding: 15px;
      }

      h4 {
        text-transform: uppercase;
      }

      h5 {
        font-size: 16px;
        line-height: 21px;
        margin: 5px 0 15px;

        @media (max-width: 575px) {
          margin: 5px 0;
        }
      }

      a {
        font-weight: 700;
        font-size: 16px;
        text-decoration: underline;
        display: flex;
        align-items: center;
        margin: 8px 0 0 0;
        transition: all 150ms linear;

        svg {
          max-height: 25px;
          margin: 0 10px 0 0;
          transition: all 150ms linear;

          path,
          line {
            transition: all 150ms linear;
          }
        }

        &:hover {
          color: #00fb6e;

          svg {
            path,
            line {
              stroke: #00fb6e;
            }
          }
        }
      }

      div {
        width: 100%;

        p {
          min-width: 140px;

          @media (max-width: 575px) {
            line-height: 22px;
          }
        }

        // &:last-child {
        //   display: flex;
        //   flex-direction: column;
        //   align-items: flex-end;
        //   text-align: left;
        // }
      }
    }

    &:hover {
      .item {
        &__inner {
          transform: translate(0%, 0%);
        }
      }
    }
  }

  .cta {
    text-align: center;
    margin: 70px 0 0 0;

    @media (max-width: 991px) {
      margin: 50px 0 0 0;
    }
  }
`
export default StyledStrategyTiles
